import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'components.order.status.title',
    defaultMessage: 'Order Status',
  },
  errorTitle: {
    id: 'components.alerts.error',
    defaultMessage: 'Error',
  },
  headline: {
    id: 'components.response.error.headline',
    defaultMessage: 'Order in process issue',
  },
  message: {
    id: 'components.response.error.message',
    defaultMessage:
      'We experienced an issue with your order but it might still have been created. Please check your Order History for the current status. If the order is missing, please contact our Support Team.',
  },
  orderHistory: {
    id: 'account.orderHistory.detail.title',
    defaultMessage: 'Order History',
  },
});
